const REST_NAMESPACE = "pump-sizing/v1";

/**
 * Prefer the localized, site-aware REST base (needed for subdirectory multisite).
 * Fall back to a root-relative path for standalone CRA local development.
 */
const getRestBase = (): string => {
	const restUrl = window.pumpSizingSettings?.restUrl?.trim();
	if (restUrl) {
		return restUrl.endsWith("/") ? restUrl : `${restUrl}/`;
	}

	return `/wp-json/${REST_NAMESPACE}/`;
};

const endpoints = {
	geocode: {
		get url() {
			return `${getRestBase()}geocode`;
		},
		requestMethod: "POST" as const,
	},
	rainfall: {
		get url() {
			return `${getRestBase()}rainfall`;
		},
		requestMethod: "POST" as const,
	},
	chartData: {
		get url() {
			return `${getRestBase()}chart-data`;
		},
		requestMethod: "POST" as const,
	},
	productData: {
		get url() {
			return `${getRestBase()}product-data`;
		},
		requestMethod: "POST" as const,
	},
	pdfDownload: {
		get url() {
			return `${getRestBase()}pdf-download`;
		},
		requestMethod: "POST" as const,
	},
	saveSubmission: {
		get url() {
			return `${getRestBase()}submissions`;
		},
		requestMethod: "POST" as const,
	},
	loadSubmission: {
		get url() {
			return `${getRestBase()}submissions/load`;
		},
		requestMethod: "POST" as const,
	},
};

export default endpoints;
